export enum EntityStoreKey {
  JobTemplateEvaluationForms = 'JobTemplateEvaluationForms',
}

export type JobTemplateInterviewTemplateItem = {
  category: string;
  id: number;
  infoDescription: string;
  infoTitle: string;
  kind: string;
  name: string;
  position: number;
  token: string;
};

export type JobTemplateInterviewTemplate = {
  id: number;
  interviewTemplate: JobTemplateInterviewTemplateItem;
  interviewTemplateId: number;
  stage: null;
  stageId: number | null;
};

export interface JobTemplateEvaluationFormsEntity {
  jobTemplateId: number;
  jobInterviewTemplates: JobTemplateInterviewTemplate[];
}
